import React from 'react';
import { WhiteButton } from '../../perts/button';
import { useInView } from 'react-intersection-observer'; 
import {FadeInSection} from '../../animaition/fade-in'; // FadeInSectionコンポーネントをインポート

import '../../../styles/section/_HomeAfterService.scss'

import GotohCrafting from '../../../assets/images/Afterservice/GotohCrafting.webp';
import ASM from '../../../assets/images/Afterservice/AfterServiceMain.webp';
import Factory from '../../../assets/images/Afterservice/factry.webp';


const HomeAfterService = () => {
    const [afterServiceText, AfterTextInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    const [afterServiceImage, AfterImageInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <div class="home-after-service-wrapper">

            <div
                ref={afterServiceImage} 
                className={`blank-side ${AfterImageInView ? 'animate' : ''}`}>

                <img src={GotohCrafting} alt="" />
                <img src={ASM} alt="" />
                <img src={Factory} alt="" />

            </div>
            <div
                ref={afterServiceText} 
                className={`text-side-wrapper ${AfterTextInView ? 'animate' : ''}`}>
                <div class="text-side-title">
                    <h3 class="has-title">
                        <span>A</span>
                        <span>F</span>
                        <span>T</span>
                        <span>E</span>
                        <span>R</span>
                        <span> </span>
                        <span>S</span>
                        <span>E</span>
                        <span>R</span>
                        <span>V</span>
                        <span>I</span>
                        <span>C</span>
                        <span>E</span>
                    </h3>
                    <FadeInSection>
                        <h1 class="has-massage">
                            あなたのお気に入りを
                            <br />その先もサポート。
                        </h1>
                    </FadeInSection>
                </div>
                <FadeInSection>
                <p>
                    生活と共にあなたの心に寄り添うものだからこそ、
                    <br />ご購入後もあなたに寄り添いしっかりサポートいたします。
                </p>
                </FadeInSection>
                <WhiteButton to='/after-service' text="詳しく知る" />
            </div>
        </div>
        // <FadeInSection>
        // </FadeInSection>
    );
};

export default HomeAfterService;
